import { TiktokImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={TiktokImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
